import { atom } from "recoil";

export const studentProfileState = atom({
  key: "studentProfileKey",
  default: {},
});
